export const RIGHT = 'right';
export const LEFT = 'left';

const doorHangTypes = [RIGHT, LEFT];

export default doorHangTypes;
